import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "../../styles/components/sidebar.css";
import logo from "../../assets/Images/altruistsmall_logo.png";
import logo_large from "../../assets/Images/altruistlarge_logowhite.png";
import { otpGenerate } from "../../services/authService";

const Sidebar = ({ isOpen, setIsOpen }) => {
  const navigate = useNavigate();
  const [openSubMenu, setOpenSubMenu] = useState(null);
  const [menuList, setMenulist] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      setIsOpen(false);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const menuItems = [
    {
      path: "/trips",
      icon: "fas fa-users",
      title: "Trips Management",
      subItems: [
        { path: "/trips/list", title: "Staff List" },
        { path: "/trips", title: "Add Trips" },
        { path: "/staff/attendance", title: "Attendance" },
      ],
    },
    {
      path: "/vehicles",
      icon: "fas fa-truck",
      title: "Vehicle Management",
      subItems: [
        { path: "/vehicles/list", title: "Vehicle List" },
        { path: "/vehicles/add", title: "Add Vehicle" },
        { path: "/vehicles/maintenance", title: "Maintenance" },
      ],
    },
    // {
    //   path: "/equipment",
    //   icon: "fas fa-tools",
    //   title: "Equipment",
    //   subItems: [
    //     { path: "/equipment/list", title: "Equipment List" },
    //     { path: "/equipment/add", title: "Add Equipment" },
    //   ],
    // },
    // {
    //   path: "/reports",
    //   icon: "fas fa-chart-bar",
    //   title: "Reports",
    // },
    // {
    //   path: "/safety",
    //   icon: "fas fa-hard-hat",
    //   title: "Safety Protocols",
    // },
  ];

  useEffect(() => {
    getMenuItems();
  }, []);

  // const getMenuItems = () => {
  //   let user = localStorage.getItem("user");
  //   let roleMenu = JSON.parse(user).role.roleMenu;
  //   // console.log(roleMenu);
  //   let arr = [];

  //   roleMenu?.forEach((element) => {
  //     if (element) {
  //       // console.log(element);
  //       let formdata = {
  //         path: element.menuMaster.route,
  //         icon: element.menuMaster.menuIcon,
  //         title: element.menuMaster.menuName,
  //         subItems: [],
  //       };

  //       element?.roleSubMenu?.forEach((element) => {
  //         let x = {
  //           path: element.subMenuMaster.route,
  //           title: element.subMenuMaster.subMenuName,
  //         };
  //         formdata.subItems.push(x);
  //       });
  //       arr.push(formdata);
  //     }
  //   });

  //   // console.log(arr);

  //   setMenulist(arr);
  // };

  const getMenuItems = () => {
    let user = localStorage.getItem("user");
    let roleMenu = JSON.parse(user)?.role?.roleMenu;
    // console.log(roleMenu);
    let arr = [];

    roleMenu?.forEach((element) => {
      if (element.status) {
        // console.log(element);
        let formdata = {
          path: element.menuMaster.route,
          icon: element.menuMaster.menuIcon,
          title: element.menuMaster.menuName,
          subItems: [],
        };

        element?.roleSubMenu?.forEach((element) => {
          let x = {
            path: element.subMenuMaster.route,
            title: element.subMenuMaster.subMenuName,
          };
          if (element.subMenuMaster.status) {
            formdata.subItems.push(x);
          }
        });
        if (element.menuMaster.status) {
          arr.push(formdata);
        }
      }
    });

    // console.log(arr);

    setMenulist(arr);
  };

  const toggleSubMenu = (index) => {
    setOpenSubMenu(openSubMenu === index ? null : index);
  };
  return (
    <div
      className={`sidebar ${!isOpen ? "collapsed" : ""} ${
        isOpen ? "open" : ""
      } ${isHovered ? "hovered" : ""}`}
      onMouseEnter={() => !isOpen && setIsHovered(true)}
      onMouseLeave={() => !isOpen && setIsHovered(false)}
    >
      <div className="sidebar-header">
        {/* <h2>Mining Portal</h2> */}
        {isOpen ? (
          <img
            src="altruist_technologies_pvt_ltd_logo.png"
            alt="Mining Portal"
            className="logo-large"
          />
        ) : (
          // <img src={logo_large} alt="Mining Portal" className="logo-large" />
          <img src="alt three.png" alt="Mining Portal" className="logo" />
        )}
      </div>

      <ul className="sidebar-menu">
        {menuList?.map((item, index) => (
          <li
            key={index}
            onMouseEnter={() => isHovered && setOpenSubMenu(index)}
            onMouseLeave={() => isHovered && setOpenSubMenu(null)}
          >
            <div onClick={() => item.subItems && toggleSubMenu(index)}>
              <NavLink
                to={item.path}
                onClick={(e) => {}}
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                <div className="menu-item-content">
                  <div className="menu-item-left">
                    <i className={item.icon}></i>
                    <span>{item.title}</span>
                  </div>
                  {(isOpen || isHovered) && item.subItems && (
                    <i
                      className={`fas fa-chevron-${
                        openSubMenu === index ? "down" : "right"
                      } submenu-arrow`}
                    ></i>
                  )}
                </div>
              </NavLink>
            </div>
            {(isOpen || isHovered) &&
              item.subItems &&
              openSubMenu === index && (
                <ul className="submenu">
                  {item.subItems.map((subItem, subIndex) => (
                    <li key={subIndex}>
                      <NavLink
                        to={subItem.path}
                        onClick={(e) => {
                          if (isMobile) {
                            setIsOpen(!isOpen);
                          }
                          localStorage.removeItem("vehicleName");
                          localStorage.removeItem("vehicleTypeId");
                        }}
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <div className="menu-item-left">
                          <i className="fas fa-circle submenu-dot"></i>
                          <span>{subItem.title}</span>
                        </div>
                      </NavLink>
                    </li>
                  ))}
                </ul>
              )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;
